<template>
  <div>
    <facit-header></facit-header>
      <div class = "profile-div col-12" v-if="!downloadChange && !showVi2viDownloads && !showESDownloads">
        <h5 class="mt-3 mb-3"> Downloads </h5>
        <br><br>
        <h5 class="mt-3 mb-3"> Applications </h5>
        <b-table  striped hover
                  :fields="fields"
                  :items="applications">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table><br><br><br>
        <h5 class="mt-3 mb-3"> Documents </h5>
        <b-table  striped hover
                  :fields="fields"
                  :items="documents">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table><br><br><br>
        <h5 class="mt-3 mb-3"> Partner Downloads </h5>
        <b-table  striped hover
                  :fields="fields"
                  :items="partnerDownloads">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table><br><br><br>
        <h5 class="mt-3 mb-3"> Demo Videos </h5>
        <b-table  striped hover
                  :fields="fields"
                  :items="videos">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table>
      </div>
      <div class = "profile-div col-12" v-if=downloadChange>
        <h5 class="mt-3 mb-3"> Downloads </h5>
        <br><br>
        <h5 class="mt-3 mb-3"> Applications </h5>
        <b-table  striped hover
                  :fields="fields"
                  :items="applicationsClient">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table><br><br><br>
        <h5 class="mt-3 mb-3"> Documents </h5>
        <b-table  striped hover
                  :fields="fields"
                  :items="documentsClient">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table><br><br><br>
      </div>
      <div class = "profile-div col-12" v-if=showVi2viDownloads>
        <h5 class="mt-3 mb-3"> Downloads </h5>
        <br><br>
        <h5 class="mt-3 mb-3"> Applications </h5>
        <b-table  striped hover
                  :fields="fields"
                  :items="applicationVi2vi">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table><br><br><br>
      </div>
      <div class = "profile-div col-12" v-if=showESDownloads>
        <h5 class="mt-3 mb-3"> Downloads </h5>
        <br><br>
        <h5 class="mt-3 mb-3"> Applications </h5>
        <b-table  striped hover
                  :fields="fields"
                  :items="applicationES">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table><br><br><br>
        <h5 class="mt-3 mb-3"> Documents </h5>
        <b-table  striped hover
                  :fields="fields"
                  :items="documentsES">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table><br><br><br>
      </div>
  </div>
</template>

<script>
import FacitHeader from '@/components/header';
import API from '@/api';
import Session from '@/Session';

export default {
  name: 'Downloads',
  components: { FacitHeader },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      applications: [],
      documents: [],
      videos: [],
      partnerDownloads: [],
      downloadChange: false,
      showVi2viDownloads: false,
      showESDownloads: false,
      applicationsClient: [],
      documentsClient: [],
      applicationVi2vi: [],
      applicationES: [],
      documentsES: [],
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'version',
          label: 'Version',
          sortable: true,
        },
        {
          key: 'size',
          label: 'Size',
          sortable: true,
        },
        {
          key: 'link',
          label: 'Downloads',
          sortable: false,
        },
      ],
    };
  },
  created() {
    let emailAddress = Session.getAccessToken().user.email
    emailAddress = emailAddress.toLowerCase()
    if (emailAddress === 'manfred.derr@simplysol.de') {
      this.downloadChange = true
    }
    if (emailAddress === 'me_asadshah@hotmail.com' || emailAddress === 'support@vi2vi-retail-solution.com') {
      this.showVi2viDownloads = true
    }
    if (emailAddress === 'g.fierro@es-sicherheit.ch' || emailAddress === 'asadriaz.shah@outlook.com') {
      this.showESDownloads = true
    }
    this.getDownloads();
  },
  methods: {
    async getDownloads() {
      const downloads = await API.get('Downloads');

      downloads.forEach(records => {
        if (records.type === 0) {
          this.applications.push(records)
        } else if (records.type === 1) {
          this.documents.push(records)
        } else if (records.type === 2) {
          this.videos.push(records)
        } else if (records.type === 6) {
          this.partnerDownloads.push(records)
        } else if (records.type === 10) {
          this.applicationsClient.push(records)
        } else if (records.type === 11) {
          this.documentsClient.push(records)
        } else if (records.type === 12) {
          this.applicationVi2vi.push(records)
        } else if (records.type === 13) {
          this.applicationES.push(records)
        } else if (records.type === 14) {
          this.documentsES.push(records)
        }
      })
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon-width {
  width: 20px !important;
  height: 20px !important;
}
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/downloads.vue